<template>
  <div class="mb-3">
    <b-form-group
      :class="title_position"
      id="example text"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      <select
        v-model="InputName"
        :disabled="FormDataType.Disabled"
        class="form-select"
        :class="{ 'is-invalid': v.$error }"
        type="text"
        @change="
          $emit('input', $event.target.value),
            $emit(
              'text',
              $event.target.options[$event.target.options.selectedIndex].text
            )
        "
      >
        <option value="">{{ $t("ortakkullanim.seciniz") }}</option>
        <option
          v-for="DataArray in FormDataType.ComboDataArray"
          :key="DataArray.Id"
          :value="DataArray.Id"
          :selected="InputName"
        >
          {{ DataArray.Value }}
        </option>
      </select>
      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index">
             <div> 
           <span v-if="error.$validator == 'required'">{{  $t("ValidationMessage.required") }}</span>
          <span v-else>{{ error.$message}}</span>
          </div>
        </div>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      InputName: "",
    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: null,
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
